<template>
  <section class="gallery">
    <figure v-for="(image, index) in images" :key="index">
      <img :src="image.imageUrl" :alt="image.caption">
      <figcaption>{{ image.caption }}</figcaption>
    </figure>
  </section>
</template>

<script>
export default {
  props: {
    images: Array
  }
};
</script>

<style scoped lang="scss">
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;

  figure {
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.6s;

    &:hover {
      transform: scale(1.10);
    }

    img {
      width: 100%;
      display: block;
      object-fit: cover;
    }

    figcaption {
      padding: 10px;
      background: #f4f4f9;
      text-align: center;
    }
  }
}

  /* Mobile*/
@media (max-width: 768px) {
  .gallery {
    grid-template-columns: 1fr; 
  }
}
/* Desktop*/
@media (min-width: 769px) {
  .gallery {
    grid-template-columns: repeat(3, 1fr); 
  }
}
</style>
